import ErrorLabelStyles from './ErrorLabel.module.scss'
export const ErrorLabel = ({ label }) => {
  return (
    <span className={ErrorLabelStyles['text']} role='alert'>
      {label}
    </span>
  )
}
